import React from 'react'
import LandingLayout from '../../layouts/landing'
import { VStack } from '@chakra-ui/react'
import InstitutionProfile from '../../components/InstitutionProfile'

export const InstitutionInfo: React.FC = () => {
  return (
    <LandingLayout>
      <VStack>
        <InstitutionProfile />
      </VStack>
    </LandingLayout>
  )
}

export default InstitutionInfo
